import React, { useState, useEffect } from "react";
import { vehiclesData } from "../CustomData/carData";
import Vehicle from "./Vehicle"; // Import the Vehicle component
import BookingModal from "./BookingModal"; // Import the BookingModal component
import "../selfcss/booknow.css";

const BookNow = () => {
  const [tripType, setTripType] = useState("one-way");
  const [formData, setFormData] = useState({
    source: "",
    destination: "",
    departureDate: "",
    arrivalDate: "",
    persons: "",
  });
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null); // For the modal

  const sources = [
    "Jaipur",
    "Delhi",
    "Agra",
    "Mathura",
    "Vrindavan",
    "Jhunjhunu",
    "Dehradun",
    "Rishikesh",
    "Haridwar",
    "Nainital",
    "Ajmer",
    "Pushkar",
    "Jodhpur",
    "Bikaner",
    "Jaisalmer",
    "Udaipur",
    "Churu",
    "Chandigarh",
    "Shree Ganganagar",
    "Hanumangarh",
    "Kota",
    "Noida", 
    "faridabad",
    "Gurgaon", 
    "Gaziyabad", 
    "Alwar",
    "Haldwani",
    "Chandigarh", 
    "Manali",
    "Zirakpur", 
    "Panchkula",
    "Kasol",
    "Amritsar", 
    "Jalandhar", 
    "Dharamsala",
    "Himachal", 
    "Shimla", 
    "Haridwar",
  ];

  const destinations = [
    "Jaipur",
    "Delhi",
    "Agra",
    "Mathura",
    "Vrindavan",
    "Jhunjhunu",
    "Dehradun",
    "Rishikesh",
    "Haridwar",
    "Nainital",
    "Ajmer",
    "Pushkar",
    "Jodhpur",
    "Bikaner",
    "Jaisalmer",
    "Udaipur",
    "Churu",
    "Chandigarh",
    "Shree Ganganagar",
    "Hanumangarh",
    "Kota",
    "Noida", 
    "faridabad",
    "Gurgaon", 
    "Gaziyabad", 
    "Alwar",
    "Haldwani",
    "Chandigarh", 
    "Manali",
    "Zirakpur", 
    "Panchkula",
    "Kasol",
    "Amritsar", 
    "Jalandhar", 
    "Dharamsala",
    "Himachal", 
    "Shimla", 
    "Haridwar",
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSearch = () => {
    // Filter vehicles based on the number of persons
    const results = vehiclesData.filter(
      (vehicle) =>
        parseInt(formData.persons) <= parseInt(vehicle.specs.passengers.split(" ")[2])
        && (vehicle.tripType===tripType)
    );
    setFilteredVehicles(results);
  };

  const handleConfirmBooking = (vehicle) => {
    setSelectedVehicle(vehicle); // Set the selected vehicle for the modal
  };

  const closeModal = () => {
    setSelectedVehicle(null); // Close the modal
  };

  // Add or remove the "modal-open" class on the body when the modal is open
  // useEffect(() => {
  //   if (selectedVehicle) {
  //     document.body.classList.add("modal-open");
  //   } else {
  //     document.body.classList.remove("modal-open");
  //   }
  // }, [selectedVehicle]);

  return (
    <div className="container py-5 book-now-container">
      <h1 className="text-center mb-4">Book Your Trip</h1>
      <div className="row g-4 book-now-content">
        {/* Form Section */}
        <div className="col-lg-6 ">
          <div className="card p-4 shadow">
            <h5 className="mb-3">Trip Details</h5>
            {/* Trip Type */}
            <div className="mb-3">
              <label className="form-label">Trip Type</label>
              <div>
                <label className="me-3">
                  <input
                    type="radio"
                    name="tripType"
                    value="one-way"
                    checked={tripType === "one-way"}
                    onChange={() => setTripType("one-way")}
                  />{" "}
                  One Way
                </label>
                <label>
                  <input
                    type="radio"
                    name="tripType"
                    value="round-trip"
                    checked={tripType === "round-trip"}
                    onChange={() => setTripType("round-trip")}
                  />{" "}
                  Round Trip
                </label>
              </div>
            </div>

            {/* Source and Destination */}
            <div className="mb-3">
              <label className="form-label">Pickup</label>
              <select
                className="form-select"
                name="source"
                value={formData.source}
                onChange={handleInputChange}
              >
                <option value="">Select Pickup Point</option>
                {sources.map((source, index) => (
                  <option key={index} value={source}>
                    {source}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Destination</label>
              <select
                className="form-select"
                name="destination"
                value={formData.destination}
                onChange={handleInputChange}
              >
                <option value="">Select Destination Point</option>
                {destinations.map((destination, index) => (
                  <option key={index} value={destination}>
                    {destination}
                  </option>
                ))}
              </select>
            </div>

            {/* Dates */}
            <div className="mb-3">
              <label className="form-label">Departure Date</label>
              <input
                type="date"
                className="form-control"
                name="departureDate"
                value={formData.departureDate}
                onChange={handleInputChange}
              />
            </div>
            {tripType === "round-trip" && (
              <div className="mb-3">
                <label className="form-label">Arrival Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="arrivalDate"
                  value={formData.arrivalDate}
                  onChange={handleInputChange}
                  disabled={tripType === "one-way"}
                />
              </div>
            )}

            {/* Number of Persons */}
            <div className="mb-3">
              <label className="form-label">Number of Persons</label>
              <input
                type="number"
                className="form-control"
                name="persons"
                value={formData.persons}
                onChange={handleInputChange}
                min="1"
              />
            </div>

            {/* Search Button */}
            <button
              className="btn btn-primary w-100"
              onClick={handleSearch}
              disabled={
                !formData.source ||
                !formData.destination ||
                !formData.departureDate ||
                !formData.persons
              }
            >
              Search Vehicles
            </button>
          </div>
        </div>

        {/* Results Section */}
        <div className="col-lg-6">
          <div className="card p-4 shadow ">
            <h5 className="mb-3  bookingavailableheader">Available Vehicles</h5>
            {filteredVehicles.length > 0 ? (
              <div className="row g-4 book-now-section">
                {filteredVehicles.map((vehicle) => (
                  <div key={vehicle.id} className="col-12">
                    <Vehicle vehicle={vehicle} onConfirmBooking={handleConfirmBooking} />
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-muted">No vehicles available for the selected criteria.</p>
            )}
          </div>
        </div>
      </div>

      {/* Modal for Booking Details */}
      {selectedVehicle && (
        <BookingModal
          tripDetails={formData}
          vehicle={selectedVehicle}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default BookNow;